import React from "react";
import photos from './photos/Boltshift.jpeg';
import photo from './photos/leisure.jpeg';
import phot from './photos/denco.png';



function Work() {
    return (
        <>
            <div id="portfolio">

                <div class="container" id="work">
                    <h2 class="section-title">My Work</h2>
                    <div class="work-list">
                        <div class="work">
                            <img

                                src={photos}
                                alt="work1"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                }
                                }
                            />

                            <div class="layer">
                                <h3>Boltshift</h3>
                                <p>
                                Your hassle-free online marketplace connecting buyers and sellers for a seamless trading experience.</p>
                                <a href="https://frontend-boltshift-u17k.vercel.app/" target="_blank"> <i class="fa-solid fa-arrow-up-right-from-square"></i></a>
                            </div>
                        </div>


                        <div class="work">
                            <img
                                src={photo}
                                alt="work2"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                }
                                }
                            />
                            <div class="layer">
                                <h3>Leisusure Space</h3>
                                <>An online marketplace connecting users with unique spaces for hourly or daily rentals.</>
                                <a href="leisure-space-frontend.vercel.appcd/" target="_blank"> <i class="fa-solid fa-arrow-up-right-from-square"></i></a>
                            </div>

                        </div>

                        <div class="work">
                            <img
                                src={phot}
                                alt="work3" />
                            <div class="layer">
                                <h3>Denco Movers</h3>
                                <p>This app facilitates effortless access to a range of moving services, including home, office, and local moving. 

                                </p>
                                <a href="https://denco-mover.vercel.app/" target="_blank"> <i class="fa-solid fa-arrow-up-right-from-square"></i></a>
                            </div>

                        </div>
                    </div>
                    <a href="https://github.com/eve-atieno" target="_blank" class="btn">See more</a>
                </div>
            </div>
        </>
    )
}

export default Work;
